import { useQuery } from "@tanstack/react-query";
import { BulkOperationsItemResult, fetchBulkOperationsItems } from "PFCore/services/bulk_operations";
import { Collection, Id, QueryOptions, QueryParams } from "PFCore/types";

import { bulkOperationsKeys } from "./query_keys";

export const useBulkOperationsItems = <T, K>(
  id: Id,
  params: Pick<QueryParams, "page" | "perPage"> = {},
  options: QueryOptions<Collection<BulkOperationsItemResult<T, K>[]>> = {}
) =>
  useQuery<Collection<BulkOperationsItemResult<T, K>[]>>({
    queryKey: bulkOperationsKeys.items(id),
    queryFn: () => fetchBulkOperationsItems<T, K>(id, params),
    ...options
  });
